import type { Meta, StoryObj } from "@storybook/react";
// import Button from "../app/components/Button";
import { Button } from "react-native";

const meta = {
    title: "_basic",
    component: Button,
    argTypes: {
        onPress: { action: "pressed the button" },
    },
} satisfies Meta<typeof Button>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {
        title: "Press me!",
    },
};
